// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
const firebaseConfig = {
    apiKey: "AIzaSyBWnDc445JbX7G3yiE1jwp_et0F2dvqhfY",
    authDomain: "page-pilot.firebaseapp.com",
    projectId: "page-pilot",
    storageBucket: "page-pilot.appspot.com",
    messagingSenderId: "486902729981",
    appId: "1:486902729981:web:63b53a56a3741f8677c294"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

export default app;